import { useEffect, useRef } from 'react';
import { useDisclosure } from '@/ui';

/**
 * Shared open/close state for the custom select dropdowns in CustomizeMode.
 * Adds outside-click and Escape dismissal so the behaviour lives in one place
 * rather than being re-implemented (and omitted) across every dropdown.
 */
export const useDropdown = () => {
  const { isOpen, onToggle, onClose } = useDisclosure();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isOpen) return;

    const handleClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        onClose();
      }
    };

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };

    document.addEventListener('mousedown', handleClick);
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('mousedown', handleClick);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose]);

  return { isOpen, toggle: onToggle, close: onClose, ref };
};
